import React from "react";
import { CiCalendarDate } from "react-icons/ci";
import {
  MdOutline4gPlusMobiledata,
  MdOutlineEmail,
  MdOutlinePhone,
} from "react-icons/md";
import Select from "react-select";
import { useGlobalContext } from "../../../../context/context";

function StepThree({ register }) {
  const { changeHandler, options, value } = useGlobalContext();
  return (
    <>
      <p>Country </p>
      <Select options={options} value={value} onChange={changeHandler} />

      <p>Gender</p>
      <div className="input_wrapper">
        <MdOutlineEmail color="#888ea8" size={22} />
        <input type="text" placeholder="Gender* " {...register("gender")} />
      </div>
      <p>Account Type</p>
      <div className="input_wrapper">
        <MdOutline4gPlusMobiledata color="#888ea8" size={22} />
        <input
          type="text"
          placeholder="Account Type* "
          {...register("accountType")}
        />
      </div>
      <p>Marital Status</p>
      <div className="input_wrapper">
        <CiCalendarDate color="#888ea8" size={22} />
        <input
          type="text"
          placeholder="Marital Status* "
          {...register("maritalstatus")}
        />
      </div>
    </>
  );
}

export default StepThree;
